import { ImageSlider } from 'components/image-slider'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IResidenceDetailMainProps } from './residence-detail-main-props.interface'
import './residence-detail-main.scss'
import { imageService } from 'services'

const ResidenceDetailMain: React.FC<IResidenceDetailMainProps> = ({ residence }) => {
  const { t } = useTranslation()
  return (
    <div className="edisu-residence-detail-main">
      <ImageSlider
        showAll={false}
        items={imageService.getResidenceImgUrls(residence).map((img) => {
          return {
            image: img,
          }
        })}
      />

      {residence.descrizione && (
        <div className="residence-description">
          <p className="residence-detail-title-big">{t('building')}</p>
          <span className="residence-detail-text">{residence.descrizione}</span>
        </div>
      )}

      {residence.orarioReception && (
        <div className="residence-schedule residence-detail-spaced">
          <p className="residence-detail-title">{t('reception_schedule').toUpperCase()}</p>
          <div className="residence-detail-text">
            {residence.orarioReception.split(/\n/).map((part, index) => (
              <p key={index}>{part}</p>
            ))}
          </div>
        </div>
      )}

      {residence.tipologiaCamere && residence.tipologiaCamere.length > 0 && (
        <div className="residence-rooms-list residence-detail-spaced">
          <p className="residence-detail-title">{t('rooms').toUpperCase()}</p>
          <ul className="residence-detail-list">
            {residence.tipologiaCamere.map((roomDescription, idx) => {
              return (
                <li key={idx}>
                  <span className="residence-detail-text">{roomDescription}</span>
                </li>
              )
            })}
          </ul>
        </div>
      )}

      {residence.dotazioniCamere && residence.dotazioniCamere.length > 0 && (
        <div className="residence-equipment-list residence-detail-spaced">
          <p className="residence-detail-text">{t('rooms_equipped_with')}</p>
          <ul className="residence-detail-list">
            {residence.dotazioniCamere.map((equipment, idx) => {
              return (
                <li key={idx}>
                  {/* TODO <IonIcon icon= mappatura equipment=>icona /> */}
                  <span className="residence-detail-text">{equipment.descrizione}</span>
                </li>
              )
            })}
          </ul>
        </div>
      )}

      {residence.serviziDescrittivi && residence.serviziDescrittivi.length > 0 && (
        <div className="residence-services-list residence-detail-spaced">
          <span className="residence-detail-title">{t('services_available').toUpperCase()}</span>
          <ul className="residence-detail-list">
            {residence.serviziDescrittivi.map((service, idx) => {
              return (
                <li key={idx}>
                  <span className="residence-detail-text">{service}</span>
                </li>
              )
            })}
          </ul>
        </div>
      )}

      {residence.serviziPagamento && residence.serviziPagamento.length > 0 && (
        <div className="residence-services-list residence-detail-spaced">
          <span className="residence-detail-title">{t('services_payment').toUpperCase()}</span>
          <ul className="residence-detail-list">
            {residence.serviziPagamento.map((service, idx) => {
              return (
                <li key={idx}>
                  <span className="residence-detail-text">{service.descrizione}</span>
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </div>
  )
}

export default ResidenceDetailMain
